<h1 class="common-popup-title text-center">
  {{ 'AUTH.DISCLAIMER_TITLE' | translate }}
</h1>

<h2 class="text" mat-dialog-content>
  {{ 'AUTH.DISCLAIMER_TEXT' | translate }}
</h2>

<div mat-dialog-actions class="confirm-action single-action">
  <button spQaId="disclaimer-popup_button_accept"
          class="btn-primary-accept"
          (click)="clickAccept()"
          cdkFocusInitial>
    {{ 'AUTH.DISCLAIMER_ACCEPT' | translate }}
  </button>
</div>
